import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LucideIconsModule } from '../../../shared/lucide-icons.module';
import { Router, RouterLink } from '@angular/router';
import { AdminService } from '../../../service/admin.service';
import { UsersManagementTabComponent } from "../users-management-tab/users-management-tab.component";
import { PortfoliosManagementTabComponent } from "../portfolios-management-tab/portfolios-management-tab.component";
import { TransactionsApprovalTabComponent } from "../transactions-approval-tab/transactions-approval-tab.component";
import { WithdrawalManagementTabComponent } from '../withdrawal-management-tab/withdrawal-management-tab.component';
import { InvestmentConsultationsTabComponent } from '../investment-consultations-tab/investment-consultations-tab.component';
import { RoiDashboardComponent } from '../roi-dashboard/roi-dashboard.component';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'app-admin-dashboard',
  imports: [CommonModule, LucideIconsModule, UsersManagementTabComponent, PortfoliosManagementTabComponent, TransactionsApprovalTabComponent,WithdrawalManagementTabComponent, InvestmentConsultationsTabComponent, RoiDashboardComponent, RouterLink, DialogModule],
  templateUrl: './admin-dashboard.component.html',
  styleUrl: './admin-dashboard.component.css'
})
export class AdminDashboardComponent {
  activeTab: string = 'portfolios';

  admin: any;
  profileLoading = false;
  profileError = '';
  showLogoutConfirm = false;

  tabs = [
    // { id: 'overview', label: 'Overview', icon: 'chart-column' },
    { id: 'portfolios', label: 'Portfolios', icon: 'chart-pie' },
    // { id: 'analytics', label: 'Analytics', icon: 'activity' },
    { id: 'users', label: 'Investors', icon: 'users' },
    // Transactions tab: fallback lucide icon plus AED SVG path
    { id: 'transactions', label: 'Transactions', icon: 'euro', iconPath: '/assets/images/icons/UAE_Dirham_Symbol.svg' },
    { id: 'withdrawal', label: 'Withdrawals', icon: 'wallet' },
    { id: 'consultations', label: 'Consultations', icon: 'clipboard-list' },
    { id: 'roi', label: 'ROI Management', icon: 'trending-up' }
    // { id: 'settings', label: 'Settings', icon: 'settings' }
  ];

  constructor(private router: Router, private adminService: AdminService) {}

  ngOnInit(): void {
    this.fetchAdminProfile();
  }

  private fetchAdminProfile(): void {
    this.profileLoading = true;
    this.profileError = '';
    const token = localStorage.getItem('authToken');
    if (!token) {
      this.profileError = 'Admin not authenticated.';
      this.profileLoading = false;
      return;
    }
    const id = this.adminService.getAdminIdFromToken();
        // You may want to decode the token and get adminId if needed, or just call a /me endpoint
    this.adminService.getProfile(token, id).subscribe({
      next: (res) => {
        this.admin = res;
        this.profileLoading = false;
      },
      error: (err) => {
        this.profileError = err?.message || 'Failed to load admin profile.';
        this.profileLoading = false;
      }
    });
  }

  setActiveTab(tabId: string): void {
    this.activeTab = tabId;
  }

  openLogoutDialog(): void {
    this.showLogoutConfirm = true;
  }

  cancelLogout(): void {
    this.showLogoutConfirm = false;
  }

  onLogout(): void {
    // Confirmed admin logout logic
    localStorage.removeItem('authToken');
    localStorage.removeItem('refreshToken');
    this.showLogoutConfirm = false;
    this.router.navigate(['/admin/login']);
  }
}
